import * as Agents from './agent/DataStoreAgent.selectors';
import * as Classifications from './classification/DataStoreClassification.selectors';
import * as Fields from './field/DataStoreField.selectors';
import * as Providers from './provider/DataStoreProvider.selectors';

import { denormalize } from 'normalizr';
import get from 'lodash/get';
import { getStore as getDB } from '../../../common/state/db/DB.store';
import schema from './DataStore.schema';

export const agent = Agents;
export const provider = Providers;
export const field = Fields;
export const classification = Classifications;

export const DOMAIN = `db.${schema.key}`;

export const getStore = state => get(state, DOMAIN) || {};

export const getEntityById = (state, id) => denormalize(id, schema, getDB(state)) || {};
export const getEntitiesForIds = (state, ids) => denormalize(ids, [schema], getDB(state));

export const getEntityFieldById = (state, { id, field }) =>
    get(getStore(state), [id, field]) || null;
